export default "/images/e7df815e9cc51c77426a7495641ce49d.avif";